module.exports = __webpack_public_path__ + "img/6.04f10665.jpg";